import { createFileRoute, notFound, redirect } from '@tanstack/react-router';
import { getCatalog, getCategoryBySlugOrId, getCategoryPage } from '~/entities/catalog/api';
import { CategoryDetailPage } from '~/pages/category-detail';

export const Route = createFileRoute('/categories_/$categoryId/')({
  loader: async ({ params, location }) => {
    await getCatalog();
    const category = await getCategoryBySlugOrId(params.categoryId);
    const page = category ? await getCategoryPage(category.id) : undefined;
    if (!category || !page) {
      throw notFound();
    }

    // An id, or a slug the category used to live at, still resolves — but only one URL should render
    // the page. The subcategory route below does the same for its own two segments.
    if (category.slug !== params.categoryId) {
      throw redirect({
        to: '/categories/$categoryId',
        params: { categoryId: category.slug },
        search: location.search,
        replace: true,
      });
    }

    return { page };
  },
  component: CategoryDetailRoute,
});

function CategoryDetailRoute() {
  const { categoryId } = Route.useParams();

  return <CategoryDetailPage categoryId={categoryId} />;
}
